require.context('../../../ui/img/', true, /\.(gif|png|jpe?g|svg)$/i);



window['renderMenu'] = function() {

    var gamesToRender = getAvailableGames();

    var element = document.querySelector('#sidebar');
    var html = '';

    gamesToRender.forEach((game) => {
        return html +=
            `<li>
                <a class="${window.location.href.indexOf(GAMES[game].url) > -1 ? 'active' : ''}"  
                href="javascript: void(0)" onclick="redirectToUrl('${BASE_URL + GAMES[game].url}')">` +
            `<img alt="${GAMES[game].url}"  src='../shared/img/${GAMES[game].url}.png' /><span>${GAMES[game].name}</span></a>` +
            `</li>`;
    });

    element.innerHTML = html;
}

/**
 * Gets game numbers as array from api response.
 *
 * @return array
 */
function getAvailableGames() {
    var responseGames = window['menu'].split('|');
    var availableGames = responseGames.filter(function(val) {
        return Object.keys(GAMES).indexOf(val) != -1;
    });
    return availableGames;
}


//////////////////
// WEBPACK FOOTER
// ./src/games/horse-racing/js/menu.js
// module id = 1570
// module chunks = 7